// Static category picker options for the admin Service form (always Polish).
// Public-facing category labels are translated via the shared `translations`
// prop (see UiTranslations + utils/translations.js), keyed under
// `service_categories.*`.
export const SERVICE_CATEGORIES = [
  { value: 'badanie', label: 'Badanie' },
  { value: 'konsultacja_medyczna', label: 'Konsultacja medyczna' },
  { value: 'zabieg', label: 'Zabieg' },
];
